
<!-- ======= Footer ======= -->
<footer id="footer">
    <!-- <div class="footer-newsletter">
        <div class="container text-white">
            <div class="row justify-content-center">
                <div class="col-lg-6">
                    <h4>Join Our Newsletter</h4>
                    <form action="" method="post">
                        <input type="email" placeholder="your_email@example.com" name="email" class="p-2 rounded-pill form-control"><input type="submit" value="Subscribe">
                    </form>
                </div>
            </div>
        </div>
    </div> -->

    <div class="footer-top">
        <div class="container">
            <div class="row justify-content-between">

                <div class="col-lg-4 col-md-7 footer-contact">
                    <h3><img height="60" src="../../assets/img/logo/logo_with_name.svg"> </h3>
                    <p>
                        <strong>Address :</strong> Level 05, East Low Block, World Trade Center, Colombo 01 <br>
                        <strong>Phone :</strong> +94 11 429 4747 / 4748<br>
                        <strong>Email :</strong>  info@hawktrading.com<br>
                    </p>
                </div>

                <div class="col-lg-3 col-md-5 footer-links">
                    <h4>Useful Links</h4>
                    <ul>
                        <li><em class="bx bx-chevron-right li-arrow"></em> <a href="#">Home</a></li>
                        <li><em class="bx bx-chevron-right li-arrow"></em> <a href="#about">About us</a></li>
                        <li><em class="bx bx-chevron-right li-arrow"></em> <a href="#webinar">Sessions</a></li>
                        <li><em class="bx bx-chevron-right li-arrow"></em> <a href="#contact">Contact Us</a></li>
                        <li><em class="bx bx-chevron-right li-arrow"></em> <a [routerLink]="['/portal']">Account</a></li>
                    </ul>
                </div>


                <div class="col-lg-3 col-md-6 footer-links">
                    <h4>Our Social Networks</h4>

                    <div class="social-links mt-3">
                        <!-- <a href="#" class="twitter"><i class="bx bxl-twitter"></i></a> -->
                        <a href="https://www.facebook.com/doksinternational" class="facebook"><i class="bx bxl-facebook"></i></a>
                        <a href="https://instagram.com/doksinternational?utm_medium=copy_link" class="instagram"><i class="bx bxl-instagram"></i></a>
                        <a href="https://t.me/doksinternational" class="telegram"><i class="bx bxl-telegram"></i></a>
                        <!-- <a href="#" class="linkedin"><i class="bx bxl-linkedin"></i></a> -->
                    </div>
                </div>

            </div>
        </div>


    </div>

</footer>
<!-- End Footer -->

<div id="preloader"></div>
<p class="w-100 text-center mb-0">Copyright © 2021 HAWK All Rights Reserved
</p>
